// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"_1CjPi","badge":"_1bKyR","label":"_3Qybc"};